import type { NavSettings } from '../../types/navSettings'
import { request } from './http'

export const getMyNavSettings = () => request<NavSettings>('/profile/nav')

export const saveMyNavSettings = (settings: NavSettings) =>
	request<NavSettings>('/profile/nav', { method: 'PUT', body: JSON.stringify(settings) })
